/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: dialRuleRestrictionsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Class of Services module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import {
  DIAL_RULE_RESTRICTIONS_ENDPOINT,
  requestDialRuleRestrictionsApi,
} from './api';

/**
 * Shared helpers for Dial Rule Restrictions module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Dial Rule Restriction in the form.
 * Pattern: /pbx/class-of-service/dial-restriction/new?duplicate={id}
 */
export const getDialRuleRestrictionDuplicateUrl = (id: string | number): string =>
  `/pbx/class-of-service/dial-restriction/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Dial Rule Restriction id.
 */
export const navigateToDialRuleRestrictionDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getDialRuleRestrictionDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Dial Rule Restriction by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteDialRuleRestrictionById = async (id: string | number): Promise<void> => {
  await requestDialRuleRestrictionsApi<null>(
    `${DIAL_RULE_RESTRICTIONS_ENDPOINT}/${id}`,
    'Failed to delete Dial Rule Restriction',
    { method: 'DELETE' },
  );
};



